import moment from "moment-timezone";
import { pick } from "lodash";
import { calculateSectionsWithAutomaticBreaks, getAutomaticBreaks, recalculateSections } from "../form/sections";
import { combineDateAndTime, renderDurationAsFormat } from "../../../../../utils/helpers/date";

export const calculateShiftsToAssign = (values: any, user: any) => {
    const date = moment(values.date).format("YYYY-MM-DD");
    let startDate = combineDateAndTime(moment(date), moment(values?.startDate || values?.sections?.[0]?.start));
    let endDate = combineDateAndTime(moment(date), moment(values?.endDate || values?.sections?.[values?.sections?.length - 1]?.end));
    const defaultSection = values?.sections?.[0];
    if (values.start && values.end && moment(endDate).isBefore(moment(startDate), "seconds")) {
        endDate = endDate.add(1, "day");
    }
    const isMandatoryBreak = user?.calculationGroup?.breaks?.manual?.mandatory;
    const breakAmount = isMandatoryBreak
        ? Number(user?.calculationGroup?.breaks?.manual?.duration || 0)
        : 0;
    let _sections: any = values?.sections || [];
    if (values.isSimple) {
        const commonProps = {
            job: user?.jobs?.find((job: any) => job?.jobId === defaultSection?.job?.id),
            location: user?.locations?.find((location: any) => location?.locationId === defaultSection?.location?.id),
            ...pick(defaultSection, ["level1", "level2", "level3", "level4", "skills", "licenses", "certifications"])
        };
        // Helper to generate a standardized section object
        const createSection = (type: any, start: any, end: any, payCode: any) => ({
            type,
            start,
            end,
            payCode,
            duration: renderDurationAsFormat(moment(end).diff(moment(start), "seconds"), "HH:mm"),
            ...commonProps
        });

        // 1. Normalize and Sort Breaks
        const breaks = (values.breaks || [])
            .map((b: any) => {
                const bStart = combineDateAndTime(moment(date), moment(b.start));
                let bEnd = combineDateAndTime(moment(date), moment(b.end));

                if (moment(bEnd).isBefore(bStart)) {
                    bEnd = moment(bEnd).add(1, "day");
                }

                return createSection("break", bStart, bEnd, b.payCode ?? defaultSection.payCode);
            })
            .sort((a: any, b: any) => moment(a.start).diff(moment(b.start)));

        // 2. Build Timeline (Interleave Regular work with Breaks)
        const sections = [];
        let cursor = startDate;

        breaks.forEach((br: any) => {
            // Add Regular work before the break if time exists
            if (moment(br.start).isAfter(cursor)) {
                sections.push(createSection("regular", cursor, br.start, defaultSection.payCode));
            }

            // Add the Break
            sections.push(br);
            cursor = br.end;
        });

        // 3. Add final Regular work segment if time remains
        if (moment(endDate).isAfter(cursor)) {
            sections.push(createSection("regular", cursor, endDate, defaultSection.payCode));
        }

        _sections = sections;
    }

    let sections: any = recalculateSections(
        _sections,
        defaultSection,
        breakAmount * 60,
        user?.calculationGroup?.breaks,
        startDate
    );

    let breaks = getAutomaticBreaks(
        user?.calculationGroup?.breaks,
        sections,
        defaultSection
    );

    const sectionBreaks = sections.filter((section: any) => section?.type === "break");
    breaks = (breaks || []).slice(sectionBreaks.length);

    let calculatedSections = sections;
    if (
        breaks.length > 0 &&
        user?.calculationGroup?.breaks?.automatic?.status
    ) {
        const lastBreakIndex = sections.findLastIndex((shift: any) => shift.type === "break");
        calculatedSections = [
            ...sections.slice(0, lastBreakIndex + 1),
            ...calculateSectionsWithAutomaticBreaks(sections.slice(lastBreakIndex + 1), breaks)
        ];
    }

    const formattedValues = {
        date,
        startDate,
        endDate,
        isSimple: values.isSimple,
        recurrence: values?.recurrence || null,
        sections: calculatedSections,
        user: user?.id
    };

    return formattedValues;
}
